import classnames from "classnames";

import { Text } from "components/ui/source";

import IconText from "../IconText";

import { iconForAmenity } from "./amenityIcons";

import styles from "./AmenitiesList.module.scss";

interface Amenity {
  name: string;
  label: string;
  active: boolean;
}

interface AmenitiesListProps {
  amenities: Amenity[];
  className?: string;
}

export default function AmenitiesList({
  className,
  amenities,
}: AmenitiesListProps) {
  if (!amenities || amenities.length == 0) return null;

  const amenityElements = amenities
    .filter(amenity => amenity.active)
    .map(amenity => (
      <IconText
        key={amenity.name}
        Icon={iconForAmenity(amenity.name)}
        title={amenity.label}
        titleTextProps={{ className: styles.title }}
      />
    ));

  return (
    <div className={classnames(className, styles.container)}>
      <Text
        className={styles.sectionTitle}
        types={["caption1"]}
        translateKey="listing:building.amenities"
      />
      <div className={styles.listContainer}>{amenityElements}</div>
    </div>
  );
}
